import { MouseEvent, useState } from "react";
import styled from "styled-components";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import {
  AppBar,
  Avatar,
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  IconButton,
  Menu,
  Stack,
  Toolbar,
  Typography,
  useTheme,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import LogoutIcon from "@mui/icons-material/Logout";
import * as React from "react";
import Logo from "./Logo";
import UserAccountIcon from "../../Theme/Icons/UserAccountIcon";
import stringAvatar from "../../Auth/AvatarHelper";

const StyledAppBar = styled(AppBar)(() => ({
  height: "64px",
  padding: "0",
}));

interface HeaderProps {
  onToggleButtonClick?: () => void;
}

export default function MdmAppBar({ onToggleButtonClick }: HeaderProps) {
  const { instance } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const handleMenu = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSignOut = () => {
    instance.logout();
    setAnchorEl(null);
  };

  const theme = useTheme();
  return (
    <Box sx={{ flexGrow: 1 }}>
      <StyledAppBar
        position="fixed"
        elevation={0}
        sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
      >
        <Toolbar>
          <IconButton
            color="secondary"
            aria-label="open drawer"
            onClick={onToggleButtonClick}
            edge="start"
            sx={{ mr: 2 }}
            size="large"
          >
            <MenuIcon />
          </IconButton>
          <Logo />
          <Typography
            variant="subtitle1"
            sx={{
              flexGrow: 1,
              ml: 4,
            }}
          >
            Ford I2M LLP
          </Typography>
          {isAuthenticated && (
            <div>
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleMenu}
                color="inherit"
              >
                <UserAccountIcon />
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "right",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                sx={{
                  "& .MuiMenu-list": {
                    padding: "0",
                  },
                }}
              >
                <Card variant="outlined">
                  <CardContent>
                    <Stack
                      direction="column"
                      spacing={2}
                      alignItems="center"
                      justifyContent="center"
                    >
                      <Avatar {...stringAvatar(instance.getActiveAccount()?.name)} />
                      {isAuthenticated && (
                        <>
                          <Typography variant="subtitle1">
                            {instance.getActiveAccount()?.name}
                          </Typography>
                          <Typography variant="subtitle2">
                            {instance.getActiveAccount()?.username}
                          </Typography>
                        </>
                      )}
                    </Stack>
                  </CardContent>
                  <CardActions sx={{ justifyContent: "center" }}>
                    <Button
                      variant="contained"
                      startIcon={<LogoutIcon />}
                      onClick={handleSignOut}
                      disableElevation
                    >
                      Sign Out
                    </Button>
                  </CardActions>
                </Card>
              </Menu>
            </div>
          )}
        </Toolbar>
      </StyledAppBar>
    </Box>
  );
}
